(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("platformized-filter-builder", [], factory);
	else if(typeof exports === 'object')
		exports["platformized-filter-builder"] = factory();
	else
		root["platformized-filter-builder"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 